'use strict'

import QuestionnaireApi from './../api/questionnaire.js'

const state = {
  data: [],
  loading: false,
  error: null
}

const getters = {
}

const mutations = {
  request (state) {
    state.error = null
    state.data = []
    state.loading = true
  },

  requestFailure (state, error) {
    state.error = error
    state.loading = false
  },

  fetchRequestSuccess (state, data) {
    state.data = data
    state.loading = false
  }
}

const actions = {
  fetch ({commit}, response) {
    commit('request')

    QuestionnaireApi.fetch(response)
     .then(data => commit('fetchRequestSuccess', data))
     .catch(error => commit('requestFailure', error))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
